var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_153_368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4316 2.25239L12.8118 4.86744C11.9147 4.13256 10.7694 3.68399 9.50002 3.68399C7.13788 3.68399 5.14796 5.20626 4.45124 7.3298L1.42102 5.01538C2.88603 2.03765 5.94488 0 9.50002 0C11.7906 0 13.8378 0.858961 15.4316 2.25239Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0896 9.00008C18.0896 11.9349 17.0159 14.2207 15.3648 15.7572L12.492 13.5335C13.4321 12.9418 14.0859 12.0255 14.3293 10.8421H9.5V7.36328H17.8844C18.0085 7.89775 18.0896 8.47039 18.0896 9.00008Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3648 15.7569C13.7948 17.2171 11.6951 17.9997 9.50002 17.9997C5.94488 17.9997 2.88603 15.9621 1.42102 12.9843L4.45124 10.6699C5.14796 12.7935 7.13788 14.3157 9.50002 14.3157C10.6596 14.3157 11.6856 14.0437 12.4921 13.5331L15.3648 15.7569Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18399 9.00025C4.18399 9.58243 4.27466 10.136 4.45122 10.6609L1.421 12.9849C0.829268 11.7871 0.5 10.4366 0.5 9.00025C0.5 7.56388 0.829268 6.2134 1.421 5.01562L4.45122 7.33005C4.27943 7.85497 4.18399 8.41806 4.18399 9.00025Z",
    fill: "#FBBC05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_153_368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5896,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.30ec5432adfcff57c995bad1e27fbe1a.svg";
export { ForwardRef as ReactComponent };